import type * as React from 'react';
import { cn } from '../../lib/cn.ts';
import { ChatCardLink } from './chat-card.tsx';
import { ChatMarkdown } from './chat-markdown.tsx';

export interface ChatLinkProps extends Omit<
  React.ComponentProps<'div'>,
  'style' | 'children'
> {
  /** What the message says. */
  text: string;
  /** The words on the link itself, e.g. "Open your calendar". */
  linkText: string;
  url: string;
}

/**
 * A message whose point is somewhere else: connecting a calendar, opening a
 * document. The sentence stays a sentence and the link stands under it, so it
 * reads as an invitation rather than a wall of underline.
 */
export function ChatLink({ text, linkText, url, className, ...props }: ChatLinkProps) {
  return (
    <div data-slot='chat-link' className={cn('flex flex-col', className)} {...props}>
      <ChatMarkdown>{text}</ChatMarkdown>
      <ChatCardLink href={url} className='mt-2 self-start'>
        {linkText}
      </ChatCardLink>
    </div>
  );
}
